import React, { useState, useEffect } from "react";
import { Bar } from "react-chartjs-2";
import { useSelector } from "react-redux";
import { fetchApi } from "../../utlis/axios";

import { Link } from "react-router-dom";
import { FiRefreshCcw } from "react-icons/fi";

const UpCommingDonation = () => {
  const { access } = useSelector((state) => state.authSlice.userInfo);
  const [donation, setDonation] = useState([]);
  const [refreshing, setRreshing]=useState(false)
  

  const getDonationData = async () => {
    try {
      const result = await fetchApi.get("donation-graph/", {
        headers: {
          Authorization: `Bearer ${access}`,
        },
      });

      if (result.status === 200) {
        const donationDataResponse = result.data;
        const monthlyMedication = {};
        const currentYear = new Date().getFullYear();

        donationDataResponse.forEach((donationData) => {
          const createdDate = new Date(donationData.created_at);
          const donationYear = createdDate.getFullYear();

          if (donationYear === currentYear && donationData.amount) {
            const month = createdDate.toLocaleString("en-US", {
              month: "long",
            });

            if (monthlyMedication[month]) {
              monthlyMedication[month] += donationData.amount; // Accumulate the amount for each month
            } else {
              monthlyMedication[month] = donationData.amount;
            }
          }
        });

        const allMonths = Array.from({ length: 12 }, (_, i) => {
          const monthName = new Date(null, i).toLocaleString("en-US", {
            month: "long",
          });
          return {
            month: monthName,
            count: monthlyMedication[monthName] || 0,
          };
        });

        setDonation(allMonths);
      }
    } catch (error) {
      console.log({ error });
    }
  };

  useEffect(() => {
    getDonationData();
  }, []);

  const handleRefresh = async()=>{
    setRreshing(true)
    await getDonationData()
    setRreshing(false)
  }

  const data = {
    labels: donation.map((label) => label?.month),
    datasets: [
      {
        label: "KWF Donation Amount",
        data: donation.map((label) => label?.count),
        backgroundColor: function(context) {
          const chart = context.chart;
          const {ctx, chartArea} = chart;
          
          if (!chartArea) {
            return null;
          }
          
          const gradient = ctx.createLinearGradient(0, chartArea.bottom, 0, chartArea.top);
          gradient.addColorStop(0, 'rgba(33, 157, 128, 0.05)');
          gradient.addColorStop(1, 'rgba(33, 157, 128, 0.3)');
          
          return gradient;
        },
        borderColor: "rgba(75,192,192,1)",
        borderWidth: 1,
      },
    ],
  };

  const options = {
    scales: {
      x: {
        type: "category",
        beginAtZero: true,
      },
      y: {
        beginAtZero: true,
        precision: 0,
      },
    },
    responsive: true,
    maintainAspectRatio: false,
    plugins: {
      legend: {
        position: "bottom",
        labels: {
          boxWidth: 15,        
          usePointStyle: false,
          boxHeight: 15,   
          padding: 10,
          color: "#000",
          font: { 
            size: 14, 
            weight: "500",
            family: "'Plus Jakarta Sans', sans-serif"       
          },
        },
      },
      
    },
  };

  

  return (
    <div className='w-full bg-white sm:p-5 p-2.5 rounded-xl shadow'>
    <div className='dashboardCard'>
      <div className='flex items-center justify-between gap-2'>
      <p style={{color:'black', fontSize:'20px'}} className='font-semibold mb-2'>
       KWF Donation
        </p>
        <span
          onClick={handleRefresh}
          disabled={refreshing}
          className={`p-2 w-max rounded-lg cursor-pointer !border-[2px] !border-[#D8D8D8] hover:bg-gray-50 transition bg-transparent shadow-none `}
        >
          <FiRefreshCcw
            className={`text-gray-600 text-lg ${
              refreshing ? "animate-spin" : ""
            }`}
          />
        </span>
      </div>
     
      <Link to='/donationdetailpage'>
    <div className="dashboard-responsive">
      <Bar data={data} options={options} height={430} />
    </div>
    </Link>
    </div>
    </div>
  );
};

export default UpCommingDonation;
